function Information() {
    return (
      <div className="p-2 sm:px-16">
        
    <br />
    <h1 className="text-center text-6xl">Information</h1>
    <div className="bg-white rounded p-3 my-5">
      <h2 className="text-red-500 text-xl text-center font-bold">*CONTENT COMING LATER - PAGE UNDER CONSTRUCTION*</h2>
    </div>
      </div>
    );
  }
  
  export default Information;
  